import React from "react";
import { motion } from "framer-motion";
import { testimonials } from "../data/portfolio";

export const TestimonialsSection = () => {
  return (
    <section
      id="testimonials"
      className="section-pad relative overflow-hidden bg-[#FFFFFF]"
      data-testid="testimonials-section"
    >
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="mb-10 md:mb-14 max-w-3xl"
        >
          <div className="eyebrow mb-6">— Words from collaborators</div>
          <h2 className="font-display font-light leading-[0.95] tracking-tight text-3xl md:text-4xl text-[#0E1A2B]">
            Gentle notes from{" "}
            <span className="text-[#E5326A]">people I've worked beside</span>.
          </h2>
        </motion.div>

        {/* Horizontal editorial rail */}
        <div className="relative">
          <div
            aria-hidden
            className="absolute left-0 right-0 top-0 h-px bg-[#0E1A2B]/15"
          />
          <ul className="flex flex-col divide-y divide-[#0E1A2B]/10">
            {testimonials.slice(0, 2).map((t, i) => (
              <motion.li
                key={t.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className="grid grid-cols-12 gap-6 md:gap-10 py-8 md:py-10 group"
                data-testid={`testimonial-${t.id}`}
              >
                {/* Swatch only (numbers removed) */}
                <div className="col-span-12 md:col-span-2 flex md:flex-col md:items-start items-baseline gap-4 md:gap-6">
                  <div
                    className="w-14 h-14 md:w-16 md:h-16 rounded-[42%_58%_46%_54%/48%_42%_58%_52%] border border-[#E4E6EC]"
                    style={{ background: t.bg }}
                    aria-hidden
                  />
                </div>

                {/* Quote */}
                <blockquote className="col-span-12 md:col-span-7 leading-[1.45] text-xl md:text-2xl lg:text-[1.75rem] text-[#0E1A2B] transition-colors duration-500">
                  <span className="text-[#E5326A] pr-1">“</span>
                  {t.quote}
                  <span className="text-[#E5326A] pl-0.5">”</span>
                </blockquote>

                {/* Attribution */}
                <figcaption className="col-span-12 md:col-span-3 flex md:flex-col justify-between md:justify-start md:items-end md:text-right gap-3 md:gap-2 md:pt-3">
                  <span className="block text-sm md:text-base text-[#0E1A2B] font-medium">
                    {t.author}
                  </span>
                  <span className="block text-[11px] tracking-[0.24em] uppercase text-[#6E7583]">
                    {t.role}
                  </span>
                </figcaption>
              </motion.li>
            ))}
          </ul>
          <div
            aria-hidden
            className="absolute left-0 right-0 bottom-0 h-px bg-[#0E1A2B]/15"
          />
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
